<template>
    <CieloLayout>
        <div class="payment-success">
            <h4 class="payment-success__title" v-text="$ml.get('pixSuccessBody')" tabindex="0" />
            <CopyQrCodeString :qr-code-string="qrCodeString" />
            <div class="payment-success__detail">
                <span v-text="$ml.get('pixDescription')" tabindex="0" />
            </div>
            <div class="payment-success__card-img">
                <img :src="qrCodeImage" class="payment-success__qr-code-image" :alt="$ml.get('altPix')" tabindex="0" />
            </div>
        </div>
    </CieloLayout>
</template>

<script>
const CieloLayout = () => import(
        /* webpackChunkName: "cielo-layout" */ '@/components/layout/CieloLayout'
);
import CopyQrCodeString from '@/components/CopyQrCodeString';
import store from '@/store';

export default {
  components: {
    CieloLayout,
    CopyQrCodeString
  },

  computed: {
    qrCodeImage: function () {
      return `data:image/png;base64, ${store.state.pixPayment.Response.QrCodeBase64Image}`;
    },

    qrCodeString: function () {
      return store.state.pixPayment.Response.QrCodeString;
    },
  },

  beforeRouteEnter(to, from, next) {
    if (!store.state.preorder.TransactionIsFinalized)
      return next(false);

    next();
  },

  beforeRouteLeave(to, from, next) {
    if (to.name == 'PaymentSuccess')
      next();
    else
      next(false);
  }
};

</script>

<style lang="scss" scoped>
.payment-success {

  display: flex;
  flex-direction: column;
  gap: 20px;

  @media screen and (max-width: 1024px) {
    align-items: center;
  }

  &__card-img {
    display: flex;
    padding: 40px 0px;
    justify-content: center;
    gap: 8px;
    border-radius: 8px;
    background: #EFF1F3;

    @media screen and (max-width: 1024px) {
      background: none;
      padding: 0px;
    }
  }

  &__detail {
    font-size: 16px;
    color: #425865;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    margin-top: 12px;

  }

  &__title {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    color: #2F363E;
    align-items: center;
    margin: 0 0 0 0;
  }

  &__qr-code-image {
    width: 264px;
    height: 266px;
  }

}
</style>
